import { useSearchParams, useLocation, Link } from "react-router-dom";
import { API } from "@/lib/api";
import { Check, Clock, Download, MapPin, Mail } from "lucide-react";

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const { state } = useLocation();
  const ref = params.get("ref");
  const token = state?.voucher_token;
  const pending = state?.pending;

  if (pending) return (
    <div className="jt-container py-20 text-center max-w-2xl mx-auto" data-testid="success-pending">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#C86D51] text-white mb-6">
        <Clock size={28}/>
      </div>
      <h1 className="font-serif text-4xl text-[#1E3A2B] mb-3">Booking received</h1>
      <p className="text-[#5C6B63] mb-6" data-testid="success-pending-note">
        Your jeep is held for 2 hours{state?.hold ? ` (until ${new Date(state.hold).toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", timeZone: "Asia/Kolkata" })} IST)` : ""}.
        {state?.online ? " Pay online any time before then from Find My Booking, or our team will contact you on WhatsApp." : " Our team will contact you on WhatsApp or phone to collect payment."}
        Once it's paid, your confirmation and voucher will be emailed{state?.email ? ` to ${state.email}` : ""}.
      </p>
      <div className="bg-white ring-1 ring-black/5 rounded-2xl p-6 mb-6">
        <div className="jt-eyebrow mb-2">Booking reference</div>
        <div className="font-mono text-2xl text-[#1E3A2B]" data-testid="success-ref">{ref}</div>
        <p className="text-xs text-[#5C6B63] mt-2">Status: awaiting payment</p>
      </div>
      <div className="flex items-center justify-center gap-3 flex-wrap">
        <Link to={`/lookup?ref=${ref}`} className="jt-pill-primary" data-testid="success-lookup-btn">{state?.online ? "Pay now" : "Booking lookup"}</Link>
        <Link to="/" className="jt-pill-outline">Back to home</Link>
      </div>
    </div>
  );

  return (
    <div className="jt-container py-20 text-center max-w-2xl mx-auto">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#1E3A2B] text-white mb-6">
        <Check size={28}/>
      </div>
      <h1 className="font-serif text-4xl text-[#1E3A2B] mb-3">Booking confirmed</h1>
      <p className="text-[#5C6B63] mb-6 flex items-center justify-center gap-2 flex-wrap" data-testid="success-email-note">
        <Mail size={15}/> A confirmation email with your voucher is on its way{state?.email ? ` to ${state.email}` : ""}.
      </p>
      <div className="bg-white ring-1 ring-black/5 rounded-2xl p-6 mb-6">
        <div className="jt-eyebrow mb-2">Booking reference</div>
        <div className="font-mono text-2xl text-[#1E3A2B]" data-testid="success-ref">{ref}</div>
        <p className="text-xs text-[#5C6B63] mt-2">Keep this reference with your mobile number to find your booking later.</p>
      </div>
      <div className="flex items-center justify-center gap-3 flex-wrap">
        {token ? (
          <a href={`${API}/vouchers/${token}`} className="jt-pill-accent" data-testid="success-voucher-btn">
            <Download size={16}/> Download voucher
          </a>
        ) : (
          <Link to="/lookup" className="jt-pill-accent" data-testid="success-lookup-voucher">Get voucher via lookup</Link>
        )}
        <Link to="/lookup" className="jt-pill-primary" data-testid="success-lookup-btn">Booking lookup</Link>
        <Link to="/" className="jt-pill-outline">Back to home</Link>
      </div>
      <p className="text-xs text-[#5C6B63] mt-10 flex items-center gap-1 justify-center"><MapPin size={13}/> Our team will WhatsApp the pickup time 24h before.</p>
    </div>
  );
}
